import { render, staticRenderFns } from "./CommuniquerEcrit.vue?vue&type=template&id=7f20f5d1"
import script from "./CommuniquerEcrit.vue?vue&type=script&lang=js"
export * from "./CommuniquerEcrit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports